import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { PiExportBold } from "react-icons/pi";
import { Link } from "react-router-dom";
import Reportselect from "./Reportselect";
import Pagination from "../Constant/Pagination";
import Select from "react-select";
import { parse, format, isValid } from "date-fns";
import {
  getBusTravelLog,
  getBusTravelLogExport,
} from "../../services/Reportservice";
const dateoption = [
  { label: "This Month", value: "this_month" },
  { label: "Last 3 Months", value: "last_3_months" },
  { label: "Last 6 Months", value: "last_6_months" },
];
const BusTravelLog = () => {
  const [exportloading, setExportloading] = useState(false);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelecteDate] = useState(dateoption[0]);
  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
    report_type: selectedDate?.value || "",
  });
  const getReport = () => {
    setLoading(true);
    getBusTravelLog(param)
      .then((res) => {
        setData(res?.data?.results?.results||[]);
        setTotal(res?.data?.count||0);
        setError("");
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getReport();
  }, [param]);
  useEffect(() => {
    setParam({ ...param, page: 1, report_type: selectedDate?.value });
  }, [selectedDate]);
  const handleexport = () => {
    setExportloading(true);
    const newparam = { ...param, export: "csv" };
    getBusTravelLogExport(newparam)
      .then((res) => {
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Bus travel-report.csv"; // set your desired filename
        a.click();

        window.URL.revokeObjectURL(url); // clean up
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setExportloading(false);
      });
  };
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  return (
    <>
      <div className="row mb-3">
        <div className="col d-flex flex-column flex-md-row justify-content-between">
          <div>
            <span
              className="text-primary"
              style={{ fontSize: "1.3rem", fontWeight: "500" }}
            >
              Bus Travel Log
            </span>
            <ol className="breadcrumb breadcrumb-arrow mb-0">
              <li className="breadcrumb-item">
                <Link to="/dashboard">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Report
              </li>
            </ol>
          </div>
          <div className="d-flex gap-2 justify-content-center align-items-center">
            <div style={{ width: "300px" }}>
              <Reportselect />
            </div>
            <button
              className="btn btn-primary d-flex align-items-center gap-1 align-self-center"
              disabled={exportloading || data.length === 0}
              onClick={handleexport}
              // style={{ height: "38px" }}
            >
              {" "}
              {exportloading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <PiExportBold size={18} />
              )}
              Export
            </button>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="d-flex justify-content-end px-4 py-3">
          <div className="flex-fill flex-md-grow-0">
            <small>Select Period</small>
            <Select
              className="react-select"
              classNamePrefix="select"
              options={dateoption}
              value={selectedDate}
              onChange={setSelecteDate}
              placeholder="Select Period"
              styles={{
                menu: (provided) => ({
                  ...provided,
                  zIndex: 999,
                }),
              }}
            />
          </div>
        </div>
        <div className="card-body  p-0">
          {loading ? (
            <div className="text-center my-4">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : error ? (
            <div className="text-center text-danger my-3">{error}</div>
          ) : data && data.length > 0 ? (
            <div className="table-responsive">
              <table className="table mb-0 align-middle fs-6">
                <thead className="table-light custom-thead">
                  <tr>
                    <th>Month</th>
                    <th>Bus</th>
                    <th>Total Running</th>
                    <th>Average Running Daily</th>
                    <th>Total Running Hours</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item) => {
                    return (
                      <tr>
                        <td>{item?.month_name || "N/A"}</td>
                        <td>
                          <Link
                            className="fw-medium"
                            to={`/bus/${item?.bus?.id}`}
                          >
                            {item?.bus?.number_plate || "N/A"}
                          </Link>
                        </td>
                        <td>
                          {item?.total_distance_km
                            ? `${item?.total_distance_km} km`
                            : "N/A"}
                        </td>
                        <td>
                          {item?.average_daily_distance_km
                            ? `${item?.average_daily_distance_km} km`
                            : "N/A"}
                        </td>
                        <td>
                          {item?.total_running_hours
                            ? `${item?.total_running_hours} hr`
                            : "N/A"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="my-2 text-center">There are no records found.</div>
          )}

          {!loading && data?.length > 0 && (
            <div className="border-top p-4">
              <Pagination
                currentPage={param.page}
                recordsPage={param.page_size}
                dataLength={total}
                handlePagination={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BusTravelLog;
